import {MenuItem} from '../../types/MenuItem'
import {getSidebarIconId} from './iconSprite.generated'

const icon = getSidebarIconId

const ICONS = {
  accept: icon('accept.svg'),
  activation: icon('icon-ativacao.svg'),
  alerts: icon('icon-alerts.svg'),
  analytics: icon('data-svgrepo-com.svg'),
  api: icon('api-services.svg'),
  apiUsers: icon('api-users.svg'),
  apuracao: icon('apuracao.svg'),
  barChart: icon('barchart-svgrepo-com.svg'),
  briefing: icon('briefing-agent.svg'),
  briefingHistory: icon('briefing-history.svg'),
  campaign: icon('campaign.svg'),
  cashback: icon('cashback.svg'),
  cadastro: icon('icon-cadastro.svg'),
  cadastroDistribuidores: icon('cadastro-distribuidores.svg'),
  cadastroLojistas: icon('cadastro-lojistas.svg'),
  cadastroProdutos: icon('cadastro-produtos.svg'),
  cadastroVendedores: icon('cadastro-vendedores.svg'),
  chipAi: icon('chip-ai.svg'),
  coupon: icon('coupon.svg'),
  dataChart: icon('data-graph-chart-report-svgrepo-com.svg'),
  dataReport: icon('data-report-svgrepo-com.svg'),
  dataTrends: icon('data-trends-svgrepo-com.svg'),
  dashboard: icon('devops-dashboard.svg'),
  distributorPriority: icon('distribuidor-prioritario.svg'),
  document: icon('document.svg'),
  documentSheet: icon('document-sheet.svg'),
  growth: icon('growth-income-investment-svgrepo-com.svg'),
  history: icon('devops-history.svg'),
  home: icon('home.svg'),
  idsEcoa: icon('menu-ids-ecoa.svg'),
  infrapay: icon('infrapay.svg'),
  inspection: icon('inspection-svgrepo-com.svg'),
  interfaceControl: icon('interface-control-svgrepo-com.svg'),
  invoice: icon('nota-fiscal.svg'),
  iconLists: icon('icon-listas.svg'),
  logs: icon('icon-logs.svg'),
  magnifying: icon('magnifying.svg'),
  management: icon('management.svg'),
  marketNews: icon('market-news-newspaper-svgrepo-com.svg'),
  marketTrends: icon('market-trends-svgrepo-com.svg'),
  masterProduct: icon('master-produto.svg'),
  orders: icon('pedidos.svg'),
  orderFlow: icon('devops-sprints.svg'),
  panel: icon('devops-panel.svg'),
  permissions: icon('permissions.svg'),
  presentation: icon('presentation-chart-graph-svgrepo-com.svg'),
  promotions: icon('promocoes.svg'),
  region: icon('icon-regional.svg'),
  reports: icon('reports.svg'),
  robotAi: icon('robot-ai-svgrepo-com.svg'),
  ruler: icon('ruler.svg'),
  score: icon('check-business-and-finance-svgrepo-com (1).svg'),
  sellerGroup: icon('seller-group.svg'),
  settings: icon('settings.svg'),
  settingsPanel: icon('settings-gear-svgrepo-com.svg'),
  spreadsheet: icon('spreadsheet.svg'),
  stats: icon('stats-financial-svgrepo-com.svg'),
  stock: icon('stock-svgrepo-com (1).svg'),
  stockForecast: icon('stock-svgrepo-com (2).svg'),
  store: icon('store.svg'),
  team: icon('devops-team.svg'),
  target: icon('icon-positivacao.svg'),
  tasks: icon('devops-tasks.svg'),
  lastStockPrice: icon('ultimo-preco-estoque.svg'),
  unilever: icon('unilever.svg'),
  users: icon('devops-users.svg'),
} as const

export const HOME_ICON = ICONS.home

const normalizeTitle = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()

// Itens conhecidos, inclusive os títulos que hoje chegam da base de dados.
// A chave é sempre o título normalizado, sem acentos ou pontuação.
const EXACT_TITLE_ICONS: Record<string, string> = {
  'pagina inicial': ICONS.home,
  gerencial: ICONS.management,
  'raio x': ICONS.inspection,
  overview: ICONS.dashboard,
  'visao geral': ICONS.dashboard,
  performance: ICONS.presentation,
  'one page gerencial': ICONS.panel,
  sellout: ICONS.barChart,
  'sellout analitico': ICONS.dataChart,
  'perfil de lojas': ICONS.store,
  indicadores: ICONS.stats,
  score: ICONS.score,
  'controle de excelencia seller': ICONS.accept,
  'performance evolucao': ICONS.dataTrends,
  'performance detalhes': ICONS.dataReport,
  promocao: ICONS.promotions,
  promocoes: ICONS.promotions,
  estoque: ICONS.stock,
  'previsao estoque': ICONS.stockForecast,
  ferramentas: ICONS.settingsPanel,
  'monitor de alertas': ICONS.alerts,
  'lista de alertas': ICONS.iconLists,
  'gerar novo alerta': ICONS.activation,
  'nivel de servico sellers': ICONS.interfaceControl,
  relatorios: ICONS.reports,
  'copiloto do vendedor': ICONS.chipAi,
  'pesquisa por loja': ICONS.magnifying,
  'venda ai': ICONS.robotAi,
  'super admin': ICONS.permissions,
  analytics: ICONS.analytics,
  'sistema de logs': ICONS.logs,
  lojistas: ICONS.store,
  'tabela de reposicao': ICONS.spreadsheet,
  produtos: ICONS.masterProduct,
  'pedido de compra': ICONS.orders,
  'pre pedidos e pedidos': ICONS.orderFlow,
  pedidos: ICONS.orders,
  'importar dados': ICONS.documentSheet,
  historico: ICONS.history,
  fornecedores: ICONS.sellerGroup,
  usuarios: ICONS.users,
  configuracoes: ICONS.settings,
  'simulador de campanha': ICONS.campaign,
  'nota fiscal': ICONS.invoice,
  'cadastro lojistas': ICONS.cadastroLojistas,
  'cadastro vendedores': ICONS.cadastroVendedores,
  apuracao: ICONS.apuracao,
  'historico preco estoque': ICONS.history,
  'distribuidor prioritario': ICONS.distributorPriority,
  'ultimo preco estoque': ICONS.lastStockPrice,
  'cashback lojistas': ICONS.cashback,
  'cashback cupons': ICONS.coupon,
  'politica de preco': ICONS.marketTrends,
  'lojas venda premiada': ICONS.growth,
  'venda premiada': ICONS.growth,
  'meta de positivacao': ICONS.accept,
  preco: ICONS.marketTrends,
  'preco praticado': ICONS.marketTrends,
  'venda assistida': ICONS.sellerGroup,
  resultados: ICONS.dataReport,
  vendedores: ICONS.cadastroVendedores,
  distribuicao: ICONS.store,
  detalhamento: ICONS.dataReport,
  'pedidos organicos': ICONS.orders,
  credito: ICONS.score,
  'credito cliente tradema': ICONS.infrapay,
  'credito cliente seller': ICONS.score,
  'analise pvm': ICONS.dataChart,
  pvm: ICONS.inspection,
  'variacao pvm': ICONS.dataTrends,
  'analise de preco': ICONS.marketTrends,
  'teste pbi': ICONS.dashboard,
  hairvolution: ICONS.masterProduct,
  share: ICONS.analytics,
  'e coa': ICONS.idsEcoa,
  metas: ICONS.target,
  'metas 2024': ICONS.target,
  batalhas: ICONS.campaign,
  'portal do seller': ICONS.api,
  'analise faturamento': ICONS.stats,
  'va resultados': ICONS.dataReport,
  'va vendedores': ICONS.cadastroVendedores,
  'va pedidos organicos': ICONS.orders,
}

type IconRule = {
  all?: string[]
  any?: string[]
  icon: string
}

// Regras por palavras do título. Elas cobrem variações e novos itens criados
// na base sem depender de rota ou de alteração no backend.
const TITLE_RULES: IconRule[] = [
  {all: ['credito', 'cliente'], any: ['tradema', 'infrapay'], icon: ICONS.infrapay},
  {all: ['venda assistida'], icon: ICONS.sellerGroup},
  {all: ['portal'], any: ['seller', 'vendedor'], icon: ICONS.api},
  {all: ['teste'], any: ['pbi', 'power bi'], icon: ICONS.dashboard},
  {all: ['pvm'], any: ['variacao', 'evolucao'], icon: ICONS.dataTrends},
  {all: ['pvm'], any: ['analise', 'resultado'], icon: ICONS.dataChart},
  {all: ['pvm'], icon: ICONS.inspection},
  {all: ['sellout'], any: ['analit', 'detalh', 'evolu'], icon: ICONS.dataChart},
  {all: ['performance'], any: ['evolu', 'tendencia', 'histor'], icon: ICONS.dataTrends},
  {all: ['performance'], any: ['detalh', 'relatorio'], icon: ICONS.dataReport},
  {all: ['controle', 'excelencia'], icon: ICONS.accept},
  {all: ['one page'], icon: ICONS.panel},
  {all: ['perfil'], any: ['loja', 'lojista', 'seller'], icon: ICONS.store},
  {all: ['previs'], any: ['estoque', 'stock'], icon: ICONS.stockForecast},
  {all: ['histor'], any: ['preco', 'estoque', 'stock'], icon: ICONS.history},
  {all: ['ultimo', 'preco'], icon: ICONS.lastStockPrice},
  {all: ['cadastro'], any: ['lojista', 'loja'], icon: ICONS.cadastroLojistas},
  {all: ['cadastro'], any: ['vendedor'], icon: ICONS.cadastroVendedores},
  {all: ['cadastro'], any: ['distribuidor', 'fornecedor'], icon: ICONS.cadastroDistribuidores},
  {all: ['cadastro'], any: ['produto'], icon: ICONS.cadastroProdutos},
  {all: ['distribuidor', 'prioritario'], icon: ICONS.distributorPriority},
  {all: ['nota', 'fiscal'], icon: ICONS.invoice},
  {all: ['politica', 'preco'], icon: ICONS.marketTrends},
  {all: ['venda', 'premiada'], icon: ICONS.growth},
  {all: ['nivel', 'servico'], icon: ICONS.interfaceControl},
  {all: ['pesquisa'], any: ['loja', 'lojista', 'seller'], icon: ICONS.magnifying},
  {all: ['monitor'], any: ['alerta', 'alert'], icon: ICONS.alerts},
  {all: ['sistema', 'log'], icon: ICONS.logs},
  {all: ['simulador'], any: ['campanha', 'promocao'], icon: ICONS.campaign},
  {all: ['raio', 'x'], icon: ICONS.inspection},
  {all: ['faixa', 'cep'], icon: ICONS.region},
  {all: ['ids', 'ecoa'], icon: ICONS.idsEcoa},
  {all: ['briefing'], any: ['histor'], icon: ICONS.briefingHistory},
  {all: ['briefing'], any: ['promoc'], icon: ICONS.promotions},
  {all: ['api'], any: ['usuario', 'user'], icon: ICONS.apiUsers},
  {any: ['overview', 'visao geral', 'dashboard', 'painel'], icon: ICONS.dashboard},
  {any: ['preco', 'pricing'], icon: ICONS.marketTrends},
  {any: ['credito', 'credit'], icon: ICONS.score},
  {any: ['resultado', 'detalhamento'], icon: ICONS.dataReport},
  {any: ['vendedor'], icon: ICONS.cadastroVendedores},
  {any: ['distribuicao'], icon: ICONS.store},
  {any: ['faturamento', 'revenue'], icon: ICONS.stats},
  {any: ['meta', 'objetivo'], icon: ICONS.target},
  {any: ['batalha', 'competicao'], icon: ICONS.campaign},
  {any: ['hairvolution'], icon: ICONS.masterProduct},
  {any: ['share'], icon: ICONS.analytics},
  {any: ['e coa'], icon: ICONS.idsEcoa},
  {any: ['analytics', 'analitico', 'analise de dados', 'data'], icon: ICONS.analytics},
  {any: ['indicador', 'kpi', 'metrica', 'estatistica'], icon: ICONS.stats},
  {any: ['performance', 'desempenho'], icon: ICONS.presentation},
  {any: ['evolucao', 'crescimento', 'tendencia'], icon: ICONS.dataTrends},
  {any: ['sellout', 'sell out'], icon: ICONS.barChart},
  {any: ['score', 'pontuacao'], icon: ICONS.score},
  {any: ['estoque', 'stock'], icon: ICONS.stock},
  {any: ['promocao', 'campanha'], icon: ICONS.promotions},
  {any: ['cashback'], icon: ICONS.cashback},
  {any: ['cupom', 'voucher'], icon: ICONS.coupon},
  {any: ['pedido', 'ordem de compra'], icon: ICONS.orders},
  {any: ['relatorio', 'report'], icon: ICONS.reports},
  {any: ['apuracao'], icon: ICONS.apuracao},
  {any: ['planilha', 'reposicao'], icon: ICONS.spreadsheet},
  {any: ['produto', 'sku'], icon: ICONS.masterProduct},
  {any: ['loja', 'lojista', 'store'], icon: ICONS.store},
  {any: ['fornecedor', 'distribuidor'], icon: ICONS.sellerGroup},
  {any: ['usuario', 'equipe', 'time', 'seller group'], icon: ICONS.users},
  {any: ['permissao', 'acesso', 'super admin'], icon: ICONS.permissions},
  {any: ['configuracao', 'ajuste'], icon: ICONS.settings},
  {any: ['alerta', 'notificacao'], icon: ICONS.alerts},
  {any: ['log'], icon: ICONS.logs},
  {any: ['historico'], icon: ICONS.history},
  {any: ['lista'], icon: ICONS.iconLists},
  {any: ['documento', 'arquivo', 'importar'], icon: ICONS.documentSheet},
  {any: ['pesquisa', 'busca', 'consulta'], icon: ICONS.magnifying},
  {any: ['copiloto', 'assistente ai', 'inteligencia artificial'], icon: ICONS.chipAi},
  {any: ['robo', 'robot', 'venda ai'], icon: ICONS.robotAi},
  {any: ['ferramenta'], icon: ICONS.settingsPanel},
  {any: ['gerencial', 'gestao', 'management'], icon: ICONS.management},
  {any: ['regional', 'regiao'], icon: ICONS.region},
  {any: ['ativacao'], icon: ICONS.activation},
  {any: ['cadastro'], icon: ICONS.cadastro},
  {any: ['api', 'servico'], icon: ICONS.api},
  {any: ['tarefa', 'task'], icon: ICONS.tasks},
  {any: ['noticia', 'news'], icon: ICONS.marketNews},
  {any: ['briefing'], icon: ICONS.briefing},
  {any: ['infrapay'], icon: ICONS.infrapay},
  {any: ['unilever'], icon: ICONS.unilever},
  {any: ['tamanho', 'medida'], icon: ICONS.ruler},
]

const FALLBACK_ICONS = [
  ICONS.dashboard,
  ICONS.dataChart,
  ICONS.presentation,
  ICONS.reports,
  ICONS.iconLists,
  ICONS.document,
  ICONS.store,
  ICONS.campaign,
  ICONS.management,
  ICONS.inspection,
]

const matchesRule = (title: string, rule: IconRule) => {
  const matchesAll = !rule.all || rule.all.every((term) => title.includes(term))
  const matchesAny = !rule.any || rule.any.some((term) => title.includes(term))
  return matchesAll && matchesAny
}

const hash = (value: string) => {
  let result = 0
  for (let index = 0; index < value.length; index += 1) {
    result = (result * 31 + value.charCodeAt(index)) >>> 0
  }
  return result
}

export const getMenuIcon = (item: MenuItem): string => {
  const title = normalizeTitle(item.label)
  const exactIcon = EXACT_TITLE_ICONS[title]
  if (exactIcon) return exactIcon

  const titleRule = TITLE_RULES.find((rule) => matchesRule(title, rule))
  if (titleRule) return titleRule.icon

  if (item.isSection) return ICONS.management
  if (item.children?.length) return ICONS.panel

  return FALLBACK_ICONS[hash(title) % FALLBACK_ICONS.length]
}
